import React, { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
const SuppliersDashboard = lazy(() => import('../containers/Suppliers/SuppliersDashboard'));
function SuppliersRouts({ url }) {
    return (React.createElement(Switch, null,
        React.createElement(Route, { path: url },
            React.createElement(SuppliersDashboard, { url: url }))));
}
export default SuppliersRouts;
